<template>
    <div>
        <div style="padding-top: 15px">
            <el-button type="primary" @click="showEditFunc()">新增</el-button>
        </div>
        <div class="common-table">
            <el-table v-loading="loading" :data="list" height="100%" row-key="userId">
                <el-table-column align="center" :label="clubName">
                    <el-table-column type="index" align="center" width="80" label="编号"/>
                    <el-table-column align="center" label="玩家ID" prop="userShowId"/>
                    <el-table-column align="center" label="玩家昵称" prop="nickName"/>
                    <el-table-column align="center" label="类型">
                        <template slot-scope="scope">{{scope.row.userType | userTypeName}}</template>
                    </el-table-column>
                    <template v-if="permissions.osm_at_super_distribution">
                        <el-table-column
                                align="center"
                                label="属性">
                            <template slot-scope="scope">{{scope.row.visitLevel | visitLevelName}}</template>
                        </el-table-column>
                    </template>
                    <el-table-column align="center" label="可用金豆" prop="availChip"/>
                    <el-table-column align="center" min-width="120" label="不可用金豆数量" prop="nonAvailChip"/>
                    <el-table-column align="center" label="牌局数" prop="rmNum"/>
                    <el-table-column align="center" label="总手数" prop="hdNum"/>
                </el-table-column>
            </el-table>
        </div>
        <div v-show="show" class="common-popup-bg">
            <div class="common-popup" style="width: 400px">
                <h3>{{form.op===1?'MT新增':'MT编辑'}}</h3>
                <el-form ref="MTRuleForm" :model="form" :rules="rules" class="common-popup-table" size="medium"
                         label-width="100px">
                    <el-form-item v-if="form.op===1" label="玩家ID：" prop="randomId">
                        <el-input type="textarea" resize="none" v-model="form.randomId" placeholder="请输入玩家ID，多个用 , 分隔"/>
                    </el-form-item>
                    <el-form-item label="类型：" prop="userType">
                        <el-select v-model="form.userType">
                            <el-option
                                    v-for="item of userTypeOptions"
                                    :key="item.label"
                                    :label="item.label"
                                    :value="item.value"/>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="form.op===1&&permissions.osm_at_super_distribution" label="属性：" prop="visitLevel">
                        <el-select v-model="form.visitLevel">
                            <el-option
                                    v-for="item of formVisitLevelOptions"
                                    :key="item.label"
                                    :label="item.label"
                                    :value="item.value"/>
                        </el-select>
                    </el-form-item>
                </el-form>
                <footer>
                    <el-button size="small" @click="close('MTRuleForm')">取消</el-button>
                    <el-button size="small" type="primary" @click="submitForm('MTRuleForm')">确定</el-button>
                </footer>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'
    import {mobileCountryCodeOptions} from 'mixins'

    export default {
        mixins: [mobileCountryCodeOptions],
        data() {
            return {
                show: false,
                clubName: 'XXX俱乐部',
                loading: false,
                list: [],
                form: {
                    op: 1,
                    randomId: '',
                    userType: '',
                    visitLevel: 'normal',
                },
                rules: {
                    randomId: [
                        {required: true, message: '请输入玩家ID', trigger: 'blur'},
                    ],
                    userType: [
                        {required: true, message: '请选择类型', trigger: 'blur'},
                    ]
                },
                userTypeOptions: [// 类型
                    {label: '中小级别盈利型', value: 1},
                    {label: '中小级别均衡型', value: 2},
                    {label: '中小级别大鱼型', value: 3},
                    {label: '大级别盈利型', value: 4},
                    {label: '大级别均衡型', value: 5},
                    {label: '大级别大鱼型', value: 6},
                ],
                formVisitLevelOptions: [// 属性
                    {label: '超级用户', value: 'operator'},
                    {label: '普通用户', value: 'normal'}
                ]
            }
        },
        computed: {
            ...mapState('login', ['permissions']),
        },
        filters: {
            userTypeName(type) {
                let arr = ['中小级别盈利型', '中小级别均衡型', '中小级别大鱼型', '大级别盈利型', '大级别均衡型', '大级别大鱼型'];
                return arr[type - 1];
            },
            visitLevelName(type) {
                switch (type) {
                    case 'normal':
                        type = '普通用户';
                        break;
                    case 'operator':
                        type = '超级账户';
                        break;
                    default:
                        break;
                }
                return type;
            }
        },
        created() {
            this.clubId = this.$route.query.clubId;
            this.clubName = this.$route.query.clubName;
            this.getList()
        },
        methods: {
            ...mapActions('at', ['getMTList', 'addMT']),
            ...mapActions('user', ['checkUser']),
            getList() {
                this.loading = true;
                this.getMTList(this.clubId).then(res => {
                    this.loading = false;
                    this.list = res.data || []
                })
            },
            showEditFunc(op = 1, obj = null) {
                this.form.op = op;
                if (op === 2) {
                    this.form = Object.assign({}, this.form, {
                        randomId: obj.userShowId,
                        userType: +obj.userType,
                        visitLevel: null,
                    })
                }
                this.show = true;
            },
            submitForm(formName) {
                debugger
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let {randomId, op, ...params} = this.form;
                        this.checkUser(randomId.split(',')).then(res => {
                            let arr = res.data.filter(item => {
                                if (randomId.indexOf(item.userIdShow) < 0) {
                                    return item
                                }
                            });
                            if (arr.length) {
                                this.$alert(`没有找到：${arr.toString()}`);
                                return
                            }
                            debugger
                            params.userId = res.data.map(c => c.userId);

                            if (op === 1) {
                                params.clubId = this.clubId;
                                this.addMT(params).then(() => {
                                    this.$message.success('添加成功');
                                    this.getList();
                                    this.close(formName)
                                })
                            }
                        });
                    }
                });
            },
            close(formName) {
                this.$refs[formName].resetFields();
                this.show = false;
            }
        }
    }
</script>